import React, { Component } from 'react'
import AppStatus from '../../../presentationals/Admin/ApplicationLeads/ApplicationStatus.component';
import { connect } from 'react-redux';
import { APIS } from '../../../../utils/api-factory';
import ConfirmationPopup from '../../../presentationals/Popup/ConfirmationPopup.component'
import EditUserDetail from '../CustomerPages/EditUserDetails.container'
import ViewUserDetailNew from '../CustomerPages/AllApplicationsEditDetails/Main';
import Popup from '../../../presentationals/Popup/Popup.component'
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { getAllDetail, getAllDetailByMail, getAllDetailByMobile, mobileVerifyApi, getAllTeaGardenApi, getformlistapi, SaveUpdateCommentsDetails, getCommunicationCommentsByUserId, getCommunicationStatusByUserId, SaveUpdateCALLDetailsStatus, getAggregatedcountByFormStatusByBucketType, GetUserCommunicationTypeByDate, GetUserCommunicationCountTypeByDate, saveImportantLoans, getAllApplicationSheetDownloadByDate, getAllDetailByName, getAppUsercommunicationLogsList, getLogsListByUserIdTypeDate, getAgreegatedcoutnByFormStatusDate } from '../AdminActionCreator.component';
import { Company_DATA } from '../../../../layouts/MainTenantconfig';
var sortJsonArray = require('sort-json-array');

const completeRemarkData = ["Profile Completed"]
const IncompleteRemarkData = [
    "Call not connected",
    "Document not complete",
    "Call Disconnected by the user",
    "Self employed",
    "Wrong number",
    "Not Interested",
    "Salaried in cash",
    "Language(Telugu)",
    "Language(Oriya)",
    "Language(malaylam)",
    "Language(Kanada)",
    "Email ID NOT OTP VERIFY",
    "Switch off",
    "Under Age 21",
    "Salary belwo 15k",
    "Ask call Back",
    "Student",
    "OTP not verified",
    "User hospitalized",
    "Already loan taken from another lender",
    "Abusive Caller",
    "Irate Customer",
    "Salary Not Fixed",
    "Will Update Later",
    "Profile Completed",
    "Delay in our repayment",
    'Online gaming entries',
    'instant debit',
    'contractual employment',
    'Joint account holder',
    'nach return/bouncing',
    'Someone else answared',
    "Custom Comment",
]

let isDeleteUser = false
let paginationNumber = 10
let itemsPerPage = 7;
class ApplicationStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forwordPageState: 1,
            confirmationPopup: false,
            confirmationText: '',
            userIdForDelete: '',
            loadarState: false,
            FilteredData: [],
            pageIndexToShow: 0,
            allDetail: '',
            userDetails: '',
            viewState: "applicationStatus",
            userOtherInfo: false,
            isError: false,
            confirmationPopupType: '',
            userIdForUnsubscribe: '',
            dataChange: '',
            newData: '',
            popupStatus: '',
            popupState: false,
            teaGardenId: '',
            employeeId: '',
            teaGardenData: [
                // {
                //     "id": 1,
                //     "teaGardenId": "kCV6VBiWe9FlUQTuiBuBoASA7NsgkRAs",
                //     "addedOn": 1653211520747,
                //     "updatedOn": 1653211520747,
                //     "tea_garden_name": "Tea Garden NE",
                //     "emailId": "teagardenne@phocket.in",
                //     "pwd": "teagardenne@123"
                // }
            ],
            tableMinPagination: 0,
            tableMaxPagination: paginationNumber,
            formStatus: '',
            statsData: '',
            startDate: new Date(),
            endDate: new Date(),
            startDateToshow: moment(new Date()).format('YYYY-MM-DD'),
            endDateToshow: moment(new Date()).format('YYYY-MM-DD'),
            formStatusList: [],
            bucketType: '',
            commPopupData: { show: false, dataValue: {} },
            PopupViewTab: "communication",
            commentData: { addedcomment: '', commentList: [] },
            communicationList: [],
            formStatusData: {},
            callDetailData: "",
            showPopupTabsValue: { callOption: false, commentOption: false },
            communicationDetailType: '',
            LogListPopup: false,
            RemarksType: '',
            RemarksListData: [],
            filterBox: "email",
            showCommServiceDataPreview: { show: false, data: {} },
            commList: { startDate: moment(new Date()).format('YYYY-MM-DD'), endDate: moment(new Date()).format('YYYY-MM-DD'), commType: '', ListData: [], totalCount: 0, currentPage: 1 },
            callPopup: false,
            ExcelDownloadData: { show: false, startDate: moment(new Date()).format('YYYY-MM-DD'), endDate: moment(new Date()).format('YYYY-MM-DD'), dateType: "formStatus" }

        }
    }
    teaChangeHandler(e, type) {
        if (type === 'teaGardenId') {
            this.setState({ teaGardenId: e.target.value }, () => this.getUpdatedApplications())
        }
        if (type === 'employeeId') {
            this.setState({ employeeId: e.target.value }, () => {
                this.getUpdatedApplications(),
                // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDate, this.state.endDate, this.state.bucketType),

                this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDate, this.state.endDate)
            })
        }
    }
    getTeaGardens() {
        getAllTeaGardenApi(1, 500, callBack => {
            this.setState({ teaGardenData: callBack })
        })
    }
    getUpdatedApplications() {
        this.setState({ loadarState: true })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
    }
    componentDidMount() {
        this.getUpdatedApplications()
        // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDateToshow, this.state.endDateToshow, "")
        this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDateToshow, this.state.endDateToshow)

        this.getTeaGardens()
        getformlistapi(callBack => {
            this.setState({ formStatusList: callBack })
        })
    }

    getAgreegatedcoutnByFormStatusDateFunction(sDate, eDate) {
        const start = moment(sDate).format("DD-MM-YYYY");
        const end = moment(eDate).format("DD-MM-YYYY");
        getAgreegatedcoutnByFormStatusDate(start, end, callBack => {
            console.log(callBack)
            if (callBack?.status == 200 && callBack?.message == "success") {
                this.setState({ formStatusData: callBack?.data })
            } else {
                this.setState({ formStatusData: {} })
            }
        })
    }

    componentWillMount() {
        // this.getAllDetail()
    }

    getAllDetail() {
        this.setState({ loadarState: true })
        this.props.getAllDetail(this.state.forwordPageState,
            (callBack) => {
                if (callBack == "error") {
                    this.setState({
                        isError: true
                    })
                } else {
                    this.setState({ loadarState: false })
                }
            });
    }

    forwordpage() {
        this.setState({ forwordPageState: this.state.forwordPageState + 1 }, () => this.getAllDetail())
    }

    backpage() {
        if (this.state.forwordPageState > 1) {
            this.setState({ forwordPageState: this.state.forwordPageState - 1 }, () => this.getAllDetail())
        }
    }
    phocketTablePagination(data, type) {
        if (type == 'back') {
            if (this.state.tableMinPagination >= paginationNumber) {
                this.setState({
                    tableMinPagination: this.state.tableMinPagination - paginationNumber,
                    tableMaxPagination: this.state.tableMaxPagination - paginationNumber,
                })
            }
        } else if (type == 'forward') {
            if (this.state.tableMaxPagination < data.length) {
                this.setState({
                    tableMaxPagination: this.state.tableMaxPagination + paginationNumber,
                    tableMinPagination: this.state.tableMinPagination + paginationNumber
                })
            }
        }
    }
    paginationHandler(type) {
        if (type == 'left') {
            if (this.state.forwordPageState > 1) {
                this.setState({
                    forwordPageState: this.state.forwordPageState - 1,
                    tableMinPagination: 0,
                    tableMaxPagination: paginationNumber,
                }, () => this.getUpdatedApplications())
            }
        }
        if (type == 'right') {
            this.setState({
                forwordPageState: this.state.forwordPageState + 1,
                tableMinPagination: 0,
                tableMaxPagination: paginationNumber,
            }, () => this.getUpdatedApplications())
        }
    }

    componentDidUpdate() {
        const { allUserDetail } = this.props;
        if (allUserDetail.length > 0) {
            if (document.getElementById("forword") != null)
                document.getElementById("forword").disabled = false;
        } else {
            if (document.getElementById("forword") != null)
                document.getElementById("forword").disabled = false;
        }
    }
    closePopup() {
        this.setState({ popupState: false })
    }
    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }
    statusHandler(e) {
        this.setState({ formStatus: e.target.value })
        this.setState({ loadarState: true })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + e.target.value + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY'))
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY'))
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })


                })
            })

    }
    filterData() {
        this.setState({ loadarState: true })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY'))
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
        // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDate, this.state.endDate, this.state.bucketType)
        this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDate, this.state.endDate)

    }
    dateHandle(e, type) {
        if (type === 'start') {
            this.setState({ startDate: e.target.value, startDateToshow: e.target.value })
        }
        if (type === 'end') {
            this.setState({ endDate: e.target.value, endDateToshow: e.target.value })


        }
    }
    handleStepChange(step) {
        // setActiveStep(step);
    };

    handleCommLogsPopup(value, data) {
        console.log("value", data, value)
        if (value == true) {
            if (data?.completeType === "complete") {
                this.setState({ RemarksListData: completeRemarkData })
            } else if (data?.incompleteType === "partialcomplete" || data?.incompleteType === "incomplete") {
                this.setState({ RemarksListData: IncompleteRemarkData })
            } else {
                this.setState({ RemarksListData: IncompleteRemarkData })
            }
            this.GetUploadedCommunicationStatusList(data)
        }
        else if (value == false) {
            this.setState({
                commentData: { addedcomment: '', commentList: [] },
                commPopupData: { show: false, dataValue: {} },
                PopupViewTab: 'communication'
            })
            this.getUpdatedApplications()
            // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDateToshow, this.state.endDateToshow, "")
            this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDateToshow, this.state.endDateToshow)

            getformlistapi(callBack => {
                this.setState({ formStatusList: callBack })
            })
        }
        this.setState({ commPopupData: { show: value, dataValue: data } })
    }

    PopupbuttonHandle(value) {
        this.setState({ PopupViewTab: value, showPopupTabsValue: { callOption: false, commentOption: false } })
        if (value === "comment") {
            this.GetUploadedCommentsList()
        } else if (value === "communication") {
            this.GetUploadedCommunicationStatusList(this.state.commPopupData.dataValue)
        } else if (value === "communicationLogs") {
            this.GetCommunicationLogsMain(0)
        }
    }

    GetCommunicationLogsMain(currentPage) {
        console.log("this.state.commPopupData?.dataValue", this.state.commPopupData?.dataValue)
        const s = moment(this.state.commList?.startDate).format("DD-MM-YYYY");
        const e = moment(this.state.commList?.endDate).format("DD-MM-YYYY");
        getLogsListByUserIdTypeDate(this.state.commPopupData?.dataValue?.userId, currentPage, itemsPerPage, this.state.commList.commType, s, e, callBack => {
            console.log("call", callBack)
            if (callBack?.status == 200 && callBack?.message == "success") {
                this.setState({ commList: { ListData: callBack?.data?.content, commType: this.state.commList.commType, startDate: this.state.commList.startDate, endDate: this.state.commList.endDate, totalCount: callBack?.data?.totalElements, currentPage: currentPage } });
            } else {
                this.setState({ commList: { ListData: [], commType: this.state.commList.commType, startDate: this.state.commList.startDate, endDate: this.state.commList.endDate, totalCount: 0, currentPage: currentPage } });
            }
        })
    }

    handlecommMain(e, type) {
        if (type === "commType") {
            this.setState({ commList: { ListData: this.state.commList?.ListData, commType: e.target.value, startDate: this.state.commList.startDate, endDate: this.state.commList.endDate, totalCount: this.state.commList.totalCount, currentPage: this.state.commList.currentPage } });
        } else if (type === "startDate") {
            this.setState({ commList: { ListData: this.state.commList?.ListData, commType: this.state.commList.commType, startDate: e.target.value, endDate: this.state.commList.endDate, totalCount: this.state.commList.totalCount, currentPage: this.state.commList.currentPage } });
        } else if (type === "endDate") {
            this.setState({ commList: { ListData: this.state.commList?.ListData, commType: this.state.commList.commType, endDate: e.target.value, startDate: this.state.commList.startDate, totalCount: this.state.commList.totalCount, currentPage: this.state.commList.currentPage } });
        }
    }

    AddCommentHandler(e) {
        this.setState((prevState) => ({
            commentData: {
                addedcomment: e.target.value,
                commentList: prevState.commentData.commentList
            }
        }));
    }

    SaveCommentInPopup() {
        const { admin } = this.props;
        const data = {
            userId: this.state.commPopupData.dataValue?.userId,
            // comment: this.state.commentData?.addedcomment,
            comment: this.state.RemarksType === "Custom Comment" ? this.state.commentData?.addedcomment : this.state.RemarksType,
            commentBy: admin.emailId
        }
        SaveUpdateCommentsDetails(data, callback => {
            if (callback == "success") {
                this.setState({
                    commentData: { addedcomment: '', commentList: [] },
                    popupState: true,
                    popupStatus: "Comment Saved"
                }, () => this.GetUploadedCommentsList())
            } else {
                this.setState({
                    popupState: true,
                    popupStatus: "Error Saving Comment"
                }, () => this.GetUploadedCommentsList())
            }
            this.removePopup()

        })

    }

    GetUploadedCommentsList() {
        getCommunicationCommentsByUserId(this.state.commPopupData.dataValue?.userId, (callback) => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                this.setState({
                    commentData: { addedcomment: '', commentList: callback?.data },
                })
            } else {
                this.setState({
                    commentData: { addedcomment: '', commentList: [] },
                })
            }
        })
    }

    GetUploadedCommunicationStatusList(data) {
        getCommunicationStatusByUserId(data?.userId, (callback) => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                this.setState({
                    communicationList: callback?.data,
                })
            } else {
                this.setState({
                    communicationList: [],
                })
            }
        })
    }

    CustomStepIcon({ active, completed, index, data }) {

        return (
            <div
                style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: '#267DFF',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    marginTop: '-16px',
                    // zIndex:'1',
                }}
            >
                {data.count}
                {/* {console.log(active, completed,)} */}
            </div>
        );
    };
    changeBucket(type) {
        this.setState({ bucketType: type })
        this.setState({ loadarState: true })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + type)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + type)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
        // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDate, this.state.endDate, type)
        this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDate, this.state.endDate)
    }

    AddCallDetailHandler(e) {
        this.setState({ callDetailData: e.target.value })
    }
    SaveCallDetailInPopup() {
        const { admin } = this.props;
        const data = {
            userId: this.state.commPopupData.dataValue?.userId,
            formStatus: this.state.commPopupData.dataValue?.formStatus,
            body: this.state.callDetailData,
            communicationType: this.state.communicationDetailType,
            empId: admin.emailId
        }


        SaveUpdateCALLDetailsStatus(data, callback => {
            if (callback == "Log saved successfully") {
                this.setState({
                    callDetailData: "",
                    communicationList: [],
                    popupState: true,
                    popupStatus: "Call Details Saved"
                }, () => this.GetUploadedCommunicationStatusList(this.state.commPopupData.dataValue))
            } else {
                this.setState({
                    popupState: true,
                    popupStatus: "Error Saving Call Details"
                }, () => this.GetUploadedCommunicationStatusList(this.state.commPopupData.dataValue))
            }
            this.removePopup()

        })
    }


    getAggregatedcountByFormStatusByBucketTypFunction(start, end, type) {
        const sDate = moment(start).format("DD-MM-YYYY");
        const eDate = moment(end).format("DD-MM-YYYY");
        getAggregatedcountByFormStatusByBucketType(sDate, eDate, type, (callback) => {
            console.log(callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                this.setState({ formStatusData: callback?.data })
            } else {
                this.setState({ formStatusData: {} })
            }
        })
    }

    HandlePopupAddBtn(type, functionality) {
        if (functionality === "open") {
            if (type === "call") {
                this.setState({ showPopupTabsValue: { callOption: true, commentOption: false } })
            } else if (type === "comment") {
                this.setState({ showPopupTabsValue: { callOption: false, commentOption: true } })
            }
        } else if (functionality === "close") {
            if (type === "call") {
                this.setState({ showPopupTabsValue: { callOption: false, commentOption: false } })
            } else if (type === "comment") {
                this.setState({ showPopupTabsValue: { callOption: false, commentOption: false } })
            }
        }

    }

    handlecommunicationDetailTypechange(e) {
        this.setState({ communicationDetailType: e.target.value })
    }

    handleLogListPopup(value) {
        this.setState({ LogListPopup: value })

    }



    MarkAsImportant(value, data) {
        console.log("data", data)
        const { admin } = this.props;
        saveImportantLoans(data, data?.loanId, value, admin?.emailId,
            (callBack) => {
                this.getUpdatedApplications()
                // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDateToshow, this.state.endDateToshow, "")
                this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDateToshow, this.state.endDateToshow)

                this.getTeaGardens()
                getformlistapi(callBack => {
                    this.setState({ formStatusList: callBack })
                })
            })
    }

    handleRemarkType(e) {
        this.setState({ RemarksType: e.target.value })
    }

    handleDownloadExcel() {
        this.setState({ loadarState: true })
        const sDate = moment(this.state.ExcelDownloadData.startDate).format('DD-MM-YYYY')
        const eDate = moment(this.state.ExcelDownloadData.endDate).format("DD-MM-YYYY")
        getAllApplicationSheetDownloadByDate(sDate, eDate, this.state.ExcelDownloadData.dateType, (callBack) => {
            this.setState({ loadarState: false })
        })
    }

    handleDownloadExcelOption(e, type) {
        if (type === "show") {
            this.setState({
                ExcelDownloadData: {
                    startDate: moment(new Date()).format('YYYY-MM-DD'),
                    endDate: moment(new Date()).format('YYYY-MM-DD'),
                    dateType: "formStatus",
                    show: e,
                }
            })
        } else {
            this.setState(prevState => ({
                ExcelDownloadData: {
                    ...prevState.ExcelDownloadData,
                    [type]: e?.target?.value
                }
            }));

        }
    }

    HandlecallPopup(value) {
        this.setState({ callPopup: value })
    }



    render() {
        const steps = this.state.statsData !== '' && (this.state.statsData.statusList).length > 0 ? (this.state.statsData.statusList).map((item, index) => ({
            // label: `${item.form_status} (${item.count})`,
            label: `${item.status}`,
            count: `${item.count}`,

            index: index + 1,
        })) : "";
        const { allUserDetail, admin } = this.props;
        if (admin != null) {
            if (admin.role != null && admin.role == 'superuser') {
                isDeleteUser = true
            }
        }
        return (
            <div className="full-height">
                {this.state.viewState == 'applicationStatus' ?
                    <div>
                        {this.state.isError ?
                            <h3 className="text-center blue-text">Something Went Wrong</h3>
                            : <AppStatus
                                bucketType={this.state.bucketType}
                                changeBucket={this.changeBucket.bind(this)}
                                statsData={this.state.statsData}
                                formStatusList={this.state.formStatusList}
                                CustomStepIcon={this.CustomStepIcon.bind(this)}
                                handleStepChange={this.handleStepChange.bind(this)}
                                steps={steps}
                                startDateToshow={this.state.startDateToshow}
                                endDateToshow={this.state.endDateToshow}
                                dateHandle={this.dateHandle.bind(this)}
                                filterData={this.filterData.bind(this)}
                                statusHandler={this.statusHandler.bind(this)}
                                formStatus={this.state.formStatus}
                                paginationHandler={this.paginationHandler.bind(this)}
                                phocketTablePagination={this.phocketTablePagination.bind(this)}
                                tableMaxPagination={this.state.tableMaxPagination}
                                tableMinPagination={this.state.tableMinPagination}
                                admin={admin}
                                teaChangeHandler={this.teaChangeHandler.bind(this)}
                                teaGardenId={this.state.teaGardenId}
                                teaGardenData={this.state.teaGardenData}
                                varifyMobile={this.varifyMobile.bind(this)}
                                forwordpage={this.forwordpage.bind(this)}
                                backpage={this.backpage.bind(this)}
                                allUserDetail={this.state.newData}
                                // allUserDetail={allUserDetail != null ? sortJsonArray(allUserDetail, 'loginDate', 'des') : ""}
                                dataFilter={this.dataFilter.bind(this)}
                                deleteUserHandler={this.deleteUserHandler.bind(this)}
                                isDeleteUser={isDeleteUser}
                                getFilterValue={this.getFilterValue.bind(this)}
                                FilteredData={this.state.FilteredData}
                                getPageValue={this.getPageValue.bind(this)}
                                pageIndexToShow={this.state.pageIndexToShow}
                                editUserHandler={this.editUserHandler.bind(this)}
                                loadarState={this.state.loadarState}
                                unsubscribeHandler={this.unsubscribeHandler.bind(this)}
                                commPopupData={this.state.commPopupData}
                                handleCommLogsPopup={this.handleCommLogsPopup.bind(this)}
                                PopupbuttonHandle={this.PopupbuttonHandle.bind(this)}
                                PopupViewTab={this.state.PopupViewTab}
                                commentData={this.state.commentData}
                                AddCommentHandler={this.AddCommentHandler.bind(this)}
                                SaveCommentInPopup={this.SaveCommentInPopup.bind(this)}
                                communicationList={this.state.communicationList}
                                AddCallDetailHandler={this.AddCallDetailHandler.bind(this)}
                                SaveCallDetailInPopup={this.SaveCallDetailInPopup.bind(this)}
                                formStatusData={this.state.formStatusData}
                                HandlePopupAddBtn={this.HandlePopupAddBtn.bind(this)}
                                showPopupTabsValue={this.state.showPopupTabsValue}
                                handlecommunicationDetailTypechange={this.handlecommunicationDetailTypechange.bind(this)}
                                communicationDetailType={this.state.communicationDetailType}
                                handleLogListPopup={this.handleLogListPopup.bind(this)}
                                LogListPopup={this.state.LogListPopup}
                                MarkAsImportant={this.MarkAsImportant.bind(this)}
                                handleRemarkType={this.handleRemarkType.bind(this)}
                                RemarksType={this.state.RemarksType}
                                RemarksListData={this.state.RemarksListData}
                                handleDownloadExcel={this.handleDownloadExcel.bind(this)}
                                filterBox={this.state.filterBox}
                                handleSelectBoxValue={this.handleSelectBoxValue.bind(this)}
                                handlePreview={this.handlePreview.bind(this)}
                                showCommServiceDataPreview={this.state.showCommServiceDataPreview}
                                commList={this.state.commList}
                                GetCommunicationLogsMain={this.GetCommunicationLogsMain.bind(this)}
                                handlecommMain={this.handlecommMain.bind(this)}
                                HandlecallPopup={this.HandlecallPopup.bind(this)}
                                callPopup={this.state.callPopup}
                                tenant={this.props.tenant}
                                ExcelDownloadData={this.state.ExcelDownloadData}
                                handleDownloadExcelOption={this.handleDownloadExcelOption.bind(this)}


                            />}
                    </div>
                    : this.state.viewState == 'editDetails' ?
                        <div>
                            <h3 className="text-center blue-text">
                                <span className="fa fa-chevron-left pull-left pointer" onClick={(e) => this.ediDetailBackHandler()} />
                                <strong className="teal-text text-uppercase">{this.state.userDetails.firstName}  ({this.state.userDetails.applicationId})</strong>
                            </h3>

                            <EditUserDetail
                                getData={this.getData.bind(this)}
                                admin={admin}
                                allDetail={this.state.allDetail}
                                userDetails={this.state.userDetails}
                                userOtherInfo={this.state.userOtherInfo}
                            />


                        </div>
                        : this.state.viewState == 'viewDetailsNew' && this.props.tenant?.COMPANY_NAME == Company_DATA?.ABHICASH ?
                            <div>
                                <ViewUserDetailNew
                                    getData={this.getData.bind(this)}
                                    ediDetailBackHandler={this.ediDetailBackHandler.bind(this)}
                                    admin={admin}
                                    allDetail={this.state.allDetail}
                                    userDetails={this.state.userDetails}
                                    userOtherInfo={this.state.userOtherInfo}
                                />
                            </div>
                            : null}
                {this.state.popupState ?
                    <Popup popupStatus={this.state.popupStatus} />
                    : ""}
                {this.state.confirmationPopup == true ?
                    <ConfirmationPopup
                        cancelLoanConfirm={this.cancelLoanConfirm.bind(this)}
                        confirmationText={this.state.confirmationText} />
                    : ""}
            </div>
        )
    }

    handlePreview(value, data) {
        this.setState({ showCommServiceDataPreview: { show: value, data: data } })
    }


    getData(val) {
        this.setState({ dataChange: val })
    }
    unsubscribeHandler(userId) {
        this.setState({
            userIdForUnsubscribe: userId,
            confirmationPopupType: 'unsubscribe',
            confirmationPopup: true,
            confirmationText: 'Are you sure to Unsubscribe this user'
        })
    }

    editUserHandler(userDetails,type) {
        this.setState({ loadarState: true })
        fetch(APIS.APPLICATION_STATUS_DETAIL_USER + userDetails.userId)


            .then(res => res.json())
            .then(res => {
                this.setState({
                    loadarState: false,
                    allDetail: res,
                    userDetails: userDetails,
                    viewState: type == "edit" ? 'editDetails' : type == "view" ? "viewDetailsNew" : "applicationStatus"
                })
            })
    }

    ediDetailBackHandler() {
        this.setState({
            viewState: 'applicationStatus'
        })
    }

    getFilterValue(filtered) {
        this.setState({ FilteredData: filtered })
    }

    getPageValue(pageIndex) {
        this.setState({ pageIndexToShow: pageIndex })
    }

    deleteUserHandler(userId) {
        this.setState({
            userIdForDelete: userId,
            confirmationPopupType: 'delete',
            confirmationPopup: true,
            confirmationText: 'Are you sure to Delete this user'
        })
    }
    varifyMobile(userId) {
        this.setState({
            userIdForDelete: userId,
            confirmationPopupType: 'Verify',
            confirmationPopup: true,
            confirmationText: 'Are you sure to Verify Mobile Number'
        })
    }

    cancelLoanConfirm(conType) {
        if (conType == 'yes') {
            if (this.state.confirmationPopupType == 'delete') {
                fetch(APIS.DELETE_COMPLETE_USER + this.state.userIdForDelete)
                    .then(res => res.text())
                    .then(text => {
                        if (text == 'success') {
                            this.setState({ confirmationPopup: false })
                            this.getAllDetail()
                        }
                    })
            } else if (this.state.confirmationPopupType == 'unsubscribe') {
                fetch(APIS.UNSUBSCRIBE_MAIL + this.state.userIdForUnsubscribe)
                    .then(res => res.text())
                    .then(text => {
                        if (text == 'success') {
                            this.setState({ confirmationPopup: false })
                        }
                    })
            }
            else if (this.state.confirmationPopupType == 'Verify') {
                this.setState({ loadarState: true })
                mobileVerifyApi(this.state.userIdForDelete, callBack => {
                    if (callBack === 'success') {
                        this.setState({ loadarState: false, confirmationPopup: false, popupState: true, popupStatus: 'Successfully Verified!' }, () => this.removePopup())
                    } else {
                        this.setState({ loadarState: false, confirmationPopup: false, popupState: true, popupStatus: 'Not Verified!' }, () => this.removePopup())

                    }
                })

            }
        } else if (conType == 'no') {
            this.setState({ confirmationPopup: false })
        }
    }

    handleSelectBoxValue(e) {
        this.setState({ filterBox: e.target.value }, () => {
            this.getUpdatedApplications()
            // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDate, this.state.endDate, this.state.bucketType)
            this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDate, this.state.endDate)
        })
    }

    dataFilter(e, filterType) {
        if (filterType == 'email') {
            let email = e.target.value
            this.setState({ loadarState: true })
            if (email.length > 4) {
                this.props.getAllDetailByMail(email, this.state.forwordPageState,
                    (callBack) => {
                        this.setState({ loadarState: false, newData: callBack })
                    });
            }
        } else if (filterType == 'mobileNo') {
            let mobile = e.target.value
            this.setState({ loadarState: true })
            if (mobile.length == 10) {
                this.props.getAllDetailByMobile(mobile, this.state.forwordPageState,
                    (callBack) => {
                        this.setState({ loadarState: false, newData: callBack })
                    });
            }
        } else if (filterType == 'name') {
            let name = e.target.value
            this.setState({ loadarState: true })
            if (name?.length > 4) {
                this.props.getAllDetailByName(name, this.state.forwordPageState,
                    (callBack) => {
                        this.setState({ loadarState: false, newData: callBack })
                    });
            }
        }
        if (e.target.value == "") {
            this.getUpdatedApplications()
            // this.getAggregatedcountByFormStatusByBucketTypFunction(this.state.startDate, this.state.endDate, this.state.bucketType)
            this.getAgreegatedcoutnByFormStatusDateFunction(this.state.startDate, this.state.endDate)
        }
    }
}



const mapStateToProps = ({ allUserDetail, tenant }) => {
    return {
        allUserDetail: allUserDetail,
        tenant: tenant.activeTenant
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getAllDetail,
        getAllDetailByMail,
        getAllDetailByMobile,
        getAllDetailByName
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationStatus);

